import { useMutation } from "@tanstack/react-query";
import { RESET_CURRENT_USER } from "../api/queries";
import { graphQLClient } from "../graphqlClient";
import { clearClimberClientStorage } from "../utils/clear-climber-storage";

// Input params:
// confirmation: String - The confirmation phrase "reset me"
// options: ResetOptions - Optional selective reset options; omit (or pass
//   { full: true }) for a full reset
// preserveEventTypes: [String] - Optional event types to keep, even on a full
//   reset. See EDUCATOR_EVENT_TYPES in useReporting.
export const useResetCurrentUser = () => {
  const resetUserMutation = async ({
    confirmation,
    options,
    preserveEventTypes,
  }) => {
    return graphQLClient.request(RESET_CURRENT_USER, {
      confirmation,
      options,
      preserveEventTypes,
    });
  };

  const mutation = useMutation({
    mutationFn: resetUserMutation,
    onSuccess: () => {
      clearClimberClientStorage();
    },
    onError: (error) => {
      console.error("Error resetting user:", error);
    },
  });

  return {
    resetUser: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    // Clears a failed attempt's error, so a dismissed-and-reopened confirmation
    // doesn't greet the user with the last failure before they've done anything.
    clearError: mutation.reset,
  };
};
